import React, { Suspense, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPropertyValue } from '../settings';
import ChatSide from './ChatSide';
import HandlerRequest from './HandlerRequest';
import { LiveEnquiries } from './LiveEnquiries';
import MemberSide from './MemberSide';
// suspense 쿼리는 실패 시 render 에서 throw 한다 — 경계가 없으면 트리 전체(강의실 화면)가
// 언마운트되므로 사이드패널 범위에서 흡수한다. (Suspense 는 pending 만 잡고 에러는 못 잡음)
class SidePanelErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(err) {
        console.error('사이드패널 로드 실패:', err);
    }
    render() {
        if (this.state.hasError) {
            return React.createElement("div", { className: "center", style: { padding: '12px' } }, "\uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.");
        }
        return this.props.children;
    }
}
const SideBarContainer = React.memo(({ isMonitoring = false, initChat, initMember, }) => {
    const individualLive = useSelector((state) => getPropertyValue(state, 'individualLive'));
    const { hideChat, hideMember, chat, member, handlerEnquiries } = useSelector((state) => state['features/base/sidebar']);
    const isChat = isMonitoring ? initChat : chat;
    const isMember = isMonitoring ? initMember : member;
    const renderChat = useMemo(() => {
        if (!isChat)
            return null;
        return React.createElement(ChatSide, { isMonitoring: isMonitoring, hideChat: hideChat });
    }, [isChat, hideChat, isMonitoring]);
    const renderMember = useMemo(() => {
        if (!isMember)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(MemberSide, { isMonitoring: isMonitoring, hideMember: hideMember })));
    }, [isMember, hideMember, isMonitoring]);
    const renderLiveEnquiries = useMemo(() => {
        if (!handlerEnquiries)
            return null;
        // suspense 쿼리(useLiveEnquiries)가 지연/실패 시 앱 루트 Suspense 까지 전파되어
        // 강의실 화면 전체가 fallback 으로 교체되던 문제 — 국소 경계로 차단.
        const fallback = React.createElement("div", { className: "center", style: { padding: '12px' } }, "\uBD88\uB7EC\uC624\uB294 \uC911...");
        if (individualLive) {
            return (React.createElement(SidePanelErrorBoundary, null,
                React.createElement(Suspense, { fallback: fallback },
                    React.createElement(LiveEnquiries, { isMonitoring: isMonitoring, hideMember: hideMember }))));
        }
        else {
            return (React.createElement(SidePanelErrorBoundary, null,
                React.createElement(Suspense, { fallback: fallback },
                    React.createElement(HandlerRequest, { isMonitoring: isMonitoring, hideMember: hideMember }))));
        }
    }, [handlerEnquiries, hideMember, isMonitoring]);
    if (!isChat && !isMember && !handlerEnquiries)
        return null;
    return (React.createElement("div", { className: "sidebar" },
        isMember && React.createElement("div", { className: "item", key: "member", style: { maxHeight: !hideMember ? isChat && !hideChat ? "30%" : "100%" : "35px" } }, renderMember),
        isChat && React.createElement("div", { className: "item", key: "chat", style: { maxHeight: !hideChat ? isMember && !hideMember ? "70%" : "100%" : "35px" } }, renderChat),
        handlerEnquiries && React.createElement("div", { className: "item", key: "handlerEnquiries" }, renderLiveEnquiries)));
});
export default SideBarContainer;
